import { Breadcrumb } from 'react-bootstrap';
import React from 'react';
import { Link } from 'react-router-dom';
import Catalogue from './features/products/Catalogue';
import CreateProduct from './features/products/CreateProduct';
import Customers from './features/customers/Customers';
import CreateCustomer from './features/customers/CreateCustomer';
import ThemeSelection from './features/settings/components/ThemeSelection';
import InventoryInsights from './features/products/inventoryInsights';

const ProductSettings = './features/products/ProductSettings';
const UpdateProfile = './features/profile/ProfileDetails';
const ProfileDetails = './features/profile/updateProfile';
const AdminDashboard = './features/adminDashboard/Dashboard';
const DemoInquires = './features/adminDashboard/Inquiries';
const Commissions = './features/dashboard/Commissions';
const Dashboard = './features/dashboard';
const Florist = './features/vendors';
const Gallery = './features/settings/components/Gallery';
const ShopInformation = './features/shopSetting/components/shopInformation';
const ShopLocations = './features/shopSetting/components/ShopLocations';
const EditShopInformation =
  './features/shopSetting/components/editShopInformation';
const BankDetails = './features/shopSetting/components/bankDetails';
const ShopOrderDetails = './features/shopSetting/components/orderDetails';
const Integrations = './features/Integrations';
const RegionalSettings = './features/shopSetting/components/regionalSettings';
const Policy = './features/shopSetting/components/policy';
const Role = './features/shopSetting/components/role';
const EditTemplate = './features/settings/EditAndPreviewTemplate/components';
const Users = './features/shopSetting/components/users';
const ThemeSettings = './features/settings/components/ThemeSettings';
const HeaderFooter = './features/settings/components/HeaderFooter';
const FooterSetting = './features/settings/components/FooterSetting';
const Settings = './features/settings/components/settings';
const Billing = './features/billing';
const AddUser = './features/shopSetting/components/addUser';
const AddRole = './features/shopSetting/components/addRole';
const AddPolicy = './features/shopSetting/components/addPolicy';
const AddNewBank = './features/shopSetting/components/addNewBank';
const WebsiteOrders = './features/settings/websiteOrders';
const Addons = './features/addons';
const AddEditAddon = './features/addons/addEditAddons';
const Inquiries = './features/Inquiries';
const newdashboard = './features/dashboard/newdashboard';
const Coupons = './features/Coupons';
const AddCoupon = './features/Coupons/AddCoupon';
const GenerateReport = './features/settings/GenerateReport';

const FloristOrder = './features/FloristOrder';
const DriverOrder = './features/DriverOrder';

export const RoutesData = [
  {
    path: '/profile',
    // component: <UpdateProfile />,
    breadCrumbHeading: 'Profile',
    breadCrumbPath: '/profile',
    importLocation: UpdateProfile,
  },
  {
    path: '/profile/edit',
    // component: <ProfileDetails />,
    breadCrumbHeading: 'Profile',
    breadCrumbPath: '/profile/edit',
    breadCrumbComponent: (
      <Breadcrumb>
        <Breadcrumb.Item as="div">
          <Link to={'/profile'}>Profile</Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item as="div" active>
          Profile
        </Breadcrumb.Item>
      </Breadcrumb>
    ),
    importLocation: ProfileDetails,
  },
  {
    path: '/admin-dashboard',
    // component: <AdminDashboard />,
    breadCrumbHeading: 'Admin Dashboard',
    breadCrumbPath: '/admin-dashboard',
    allowedRoles: ['superAdmin'],
    importLocation: AdminDashboard,
    breadCrumbComponent: (
      <Breadcrumb>
        <Breadcrumb.Item as="div">
          <span>Admin</span>
        </Breadcrumb.Item>
        <Breadcrumb.Item as="div" active>
          Dashboard
        </Breadcrumb.Item>
      </Breadcrumb>
    ),
  },
  {
    path: '/florist-orders',
    // component: <AdminDashboard />,
    breadCrumbHeading: 'Florist Orders',
    breadCrumbPath: '/florist-orders',
    allowedRoles: ['superAdmin'],
    importLocation: FloristOrder,
    breadCrumbComponent: (
      <Breadcrumb>
        <Breadcrumb.Item as="div">
          <span>Admin</span>
        </Breadcrumb.Item>
        <Breadcrumb.Item as="div" active>
          Florist Orders
        </Breadcrumb.Item>
      </Breadcrumb>
    ),
  },
  {
    path: '/demo-inquires',
    // component: <AdminDashboard />,
    breadCrumbHeading: 'Demo Inquires',
    breadCrumbPath: '/demo-inquires',
    allowedRoles: ['superAdmin'],
    importLocation: DemoInquires,
    breadCrumbComponent: (
      <Breadcrumb>
        <Breadcrumb.Item as="div">
          <span>Admin</span>
        </Breadcrumb.Item>
        <Breadcrumb.Item as="div" active>
          Demo Inquires
        </Breadcrumb.Item>
      </Breadcrumb>
    ),
  },
  {
    path: '/commission-insights',
    // component: <AdminDashboard />,
    breadCrumbHeading: 'Commission Insights',
    breadCrumbPath: '/commission-insights',
    allowedRoles: ['superAdmin'],
    importLocation: Commissions,
    breadCrumbComponent: (
      <Breadcrumb>
        <Breadcrumb.Item as="div">
          <span>Admin</span>
        </Breadcrumb.Item>
        <Breadcrumb.Item as="div" active>
          Commission Insights
        </Breadcrumb.Item>
      </Breadcrumb>
    ),
  },
  {
    path: '/dashboard',
    // component: <Dashboard />,
    breadCrumbHeading: 'Dashboard',
    breadCrumbPath: '/dashboard',
    importLocation: Dashboard,
  },
  {
    path: '/products',
    component: <Catalogue isCatalogue />,
    breadCrumbHeading: 'Catalog',
    breadCrumbPath: '/products',
    allowedRoles: ['superAdmin'],
  },
  {
    path: '/products/new',
    component: <CreateProduct isCatalogue />,
    breadCrumbHeading: 'Catalog',
    breadCrumbPath: '/products/new',
  },
  {
    path: '/products/:id',
    component: <CreateProduct isCatalogue />,
    breadCrumbHeading: 'Catalog',
    breadCrumbPath: '/products/:id',
    allowedRoles: ['superAdmin'],
  },
  {
    path: '/products/details/:id',
    component: <CreateProduct isCatalogue isViewOnly />,
    breadCrumbHeading: 'Catalog',
    breadCrumbPath: '/products/details/:id',
    breadCrumbComponent: (
      <Breadcrumb>
        <Breadcrumb.Item as="div">
          <span>Catalog</span>
        </Breadcrumb.Item>
        <Breadcrumb.Item as="div" active>
          Details
        </Breadcrumb.Item>
      </Breadcrumb>
    ),
  },
  {
    path: '/admin/florists',
    // component: <Florist />,
    breadCrumbHeading: 'Florists',
    breadCrumbPath: '/admin/florists',
    importLocation: Florist,
  },
  {
    path: '/admin/images-gallery',
    // component: <Gallery />,
    breadCrumbHeading: 'Images Gallery',
    breadCrumbPath: '/admin/images-gallery',
    importLocation: Gallery,
  },
  {
    path: '/shopInfo/details',
    // component: <ShopInformation />,
    breadCrumbHeading: 'Shop Information',
    breadCrumbPath: '/shopInfo/details',
    breadCrumbComponent: (
      <Breadcrumb>
        <Breadcrumb.Item as="div">
          <span>Your Shop</span>
        </Breadcrumb.Item>
        <Breadcrumb.Item as="div" active>
          Shop Information
        </Breadcrumb.Item>
      </Breadcrumb>
    ),
    importLocation: ShopInformation,
  },
  {
    path: '/shopInfo/details/edit',
    // component: <EditShopInformation />,
    breadCrumbHeading: 'Shop Information',
    breadCrumbPath: '/shopInfo/details/edit',
    breadCrumbComponent: (
      <Breadcrumb>
        <Breadcrumb.Item as="div">
          <span>Your Shop</span>
        </Breadcrumb.Item>
        <Breadcrumb.Item as="div" active>
          Shop Information
        </Breadcrumb.Item>
      </Breadcrumb>
    ),
    importLocation: EditShopInformation,
  },

  {
    path: '/shopInfo/financials',
    // component: <BankDetails />,
    breadCrumbHeading: 'Financials',
    breadCrumbPath: '/shopInfo/financials',
    breadCrumbComponent: (
      <Breadcrumb>
        <Breadcrumb.Item as="div">
          <span>Your Shop</span>
        </Breadcrumb.Item>
        <Breadcrumb.Item as="div" active>
          Financials
        </Breadcrumb.Item>
      </Breadcrumb>
    ),
    importLocation: BankDetails,
  },
  {
    path: '/shopInfo/financials/add',
    // component: <AddNewBank />,
    breadCrumbHeading: 'Financials',
    breadCrumbPath: '/shopInfo/financials/add',
    breadCrumbComponent: (
      <Breadcrumb>
        <Breadcrumb.Item as="div">
          <span>Your Shop</span>
        </Breadcrumb.Item>
        <Breadcrumb.Item as="div" active>
          Financials
        </Breadcrumb.Item>
      </Breadcrumb>
    ),
    importLocation: AddNewBank,
  },
  {
    path: '/shopInfo/financials/edit/:id',
    // component: <AddNewBank editPage />,
    breadCrumbHeading: 'Financials',
    breadCrumbPath: '/shopInfo/financials/edit/:id',
    breadCrumbComponent: (
      <Breadcrumb>
        <Breadcrumb.Item as="div">
          <span>Your Shop</span>
        </Breadcrumb.Item>
        <Breadcrumb.Item as="div" active>
          Financials
        </Breadcrumb.Item>
      </Breadcrumb>
    ),
    importLocation: AddNewBank,
    parameterProps: {
      editPage: true,
    },
  },
  {
    path: '/shopInfo/integrations',
    // component: <Integrations />,
    breadCrumbHeading: 'Integrations',
    breadCrumbPath: '/shopInfo/integrations',
    breadCrumbComponent: (
      <Breadcrumb>
        <Breadcrumb.Item as="div">
          <span>Your Shop</span>
        </Breadcrumb.Item>
        <Breadcrumb.Item as="div" active>
          Integrations
        </Breadcrumb.Item>
      </Breadcrumb>
    ),
    importLocation: Integrations,
  },
  {
    path: '/shopInfo/orderSettings',
    // component: <ShopOrderDetails />,
    breadCrumbHeading: 'Shop Settings',
    breadCrumbPath: '/shopInfo/orderSettings',
    breadCrumbComponent: (
      <Breadcrumb>
        <Breadcrumb.Item as="div">
          <span>Your Shop</span>
        </Breadcrumb.Item>
        <Breadcrumb.Item as="div" active>
          Shop Settings
        </Breadcrumb.Item>
      </Breadcrumb>
    ),
    importLocation: ShopOrderDetails,
  },
  {
    path: '/shopInfo/regionalSettings',
    // component: <RegionalSettings />,
    breadCrumbHeading: 'Regional Settings',
    breadCrumbPath: '/shopInfo/regionalSettings',
    breadCrumbComponent: (
      <Breadcrumb>
        <Breadcrumb.Item as="div">
          <span>Your Shop</span>
        </Breadcrumb.Item>
        <Breadcrumb.Item as="div" active>
          Regional Settings
        </Breadcrumb.Item>
      </Breadcrumb>
    ),
    importLocation: RegionalSettings,
  },
  {
    path: '/shopInfo/policy',
    // component: <Policy />,
    breadCrumbHeading: 'Policy',
    breadCrumbPath: '/shopInfo/policy',
    breadCrumbComponent: (
      <Breadcrumb>
        <Breadcrumb.Item as="div">
          <span>Your Shop</span>
        </Breadcrumb.Item>
        <Breadcrumb.Item as="div" active>
          Policy
        </Breadcrumb.Item>
      </Breadcrumb>
    ),
    importLocation: Policy,
  },
  {
    path: '/shopInfo/policy/add',
    // component: <AddPolicy />,
    breadCrumbHeading: 'Policy',
    breadCrumbPath: '/shopInfo/policy/add',
    breadCrumbComponent: (
      <Breadcrumb>
        <Breadcrumb.Item as="div">
          <span>Your Shop</span>
        </Breadcrumb.Item>
        <Breadcrumb.Item as="div" active>
          Policy
        </Breadcrumb.Item>
      </Breadcrumb>
    ),
    importLocation: AddPolicy,
  },
  {
    path: '/shopInfo/policy/edit/:id',
    // component: <AddPolicy editPage />,
    breadCrumbHeading: 'Policy',
    breadCrumbPath: '/shopInfo/policy/edit/:id',
    breadCrumbComponent: (
      <Breadcrumb>
        <Breadcrumb.Item as="div">
          <span>Your Shop</span>
        </Breadcrumb.Item>
        <Breadcrumb.Item as="div" active>
          Policy
        </Breadcrumb.Item>
      </Breadcrumb>
    ),
    importLocation: AddPolicy,
    parameterProps: {
      editPage: true,
    },
  },
  {
    path: '/shopInfo/role',
    // component: <Role />,
    breadCrumbHeading: 'Role',
    breadCrumbPath: '/shopInfo/role',
    breadCrumbComponent: (
      <Breadcrumb>
        <Breadcrumb.Item as="div">
          <span>Your Shop</span>
        </Breadcrumb.Item>
        <Breadcrumb.Item as="div" active>
          Role
        </Breadcrumb.Item>
      </Breadcrumb>
    ),
    // allowedRoleIds: [2],
    importLocation: Role,
  },
  {
    path: '/shopInfo/role/add',
    // component: <AddRole />,
    breadCrumbHeading: 'Role',
    breadCrumbPath: '/shopInfo/role/add',
    breadCrumbComponent: (
      <Breadcrumb>
        <Breadcrumb.Item as="div">
          <span>Your Shop</span>
        </Breadcrumb.Item>
        <Breadcrumb.Item as="div" active>
          Role
        </Breadcrumb.Item>
      </Breadcrumb>
    ),
    // allowedRoleIds: [2],
    importLocation: AddRole,
  },
  {
    path: '/shopInfo/role/edit/:id',
    // component: <AddRole editPage />,
    breadCrumbHeading: 'Role',
    breadCrumbPath: '/shopInfo/role/edit/:id',
    breadCrumbComponent: (
      <Breadcrumb>
        <Breadcrumb.Item as="div">
          <span>Your Shop</span>
        </Breadcrumb.Item>
        <Breadcrumb.Item as="div" active>
          Role
        </Breadcrumb.Item>
      </Breadcrumb>
    ),
    // allowedRoleIds: [2],
    importLocation: AddRole,
    parameterProps: {
      editPage: true,
    },
  },
  {
    path: '/shopInfo/role/edit/:id',
    // component: <AddRole editPage />,
    breadCrumbHeading: 'Role',
    breadCrumbPath: '/shopInfo/role/edit/:id',
    breadCrumbComponent: (
      <Breadcrumb>
        <Breadcrumb.Item as="div">
          <span>Your Shop</span>
        </Breadcrumb.Item>
        <Breadcrumb.Item as="div" active>
          Role
        </Breadcrumb.Item>
      </Breadcrumb>
    ),
    // allowedRoleIds: [2],
    importLocation: AddRole,
    parameterProps: {
      editPage: true,
    },
  },
  {
    path: '/shopInfo/users',
    // component: <Users />,
    breadCrumbHeading: 'Users',
    breadCrumbPath: '/shopInfo/users',
    breadCrumbComponent: (
      <Breadcrumb>
        <Breadcrumb.Item as="div">
          <span>Your Shop</span>
        </Breadcrumb.Item>
        <Breadcrumb.Item as="div" active>
          Users
        </Breadcrumb.Item>
      </Breadcrumb>
    ),
    // allowedRoleIds: [2],
    importLocation: Users,
  },
  {
    path: '/shopInfo/users/add',
    // component: <AddUser />,
    breadCrumbHeading: 'User',
    breadCrumbPath: '/shopInfo/users/add',
    breadCrumbComponent: (
      <Breadcrumb>
        <Breadcrumb.Item as="div">
          <span>Your Shop</span>
        </Breadcrumb.Item>
        <Breadcrumb.Item as="div" active>
          User
        </Breadcrumb.Item>
      </Breadcrumb>
    ),
    // allowedRoleIds: [2],
    importLocation: AddUser,
  },
  {
    path: '/shopInfo/users/edit/:id',
    breadCrumbHeading: 'Users',
    breadCrumbPath: '/shopInfo/users/edit/:id',
    breadCrumbComponent: (
      <Breadcrumb>
        <Breadcrumb.Item as="div">
          <span>Your Shop</span>
        </Breadcrumb.Item>
        <Breadcrumb.Item as="div" active>
          Users
        </Breadcrumb.Item>
      </Breadcrumb>
    ),
    // allowedRoleIds: [2],
    importLocation: AddUser,
    parameterProps: {
      editPage: true,
    },
  },
  {
    path: '/billing',
    breadCrumbHeading: 'Billing',
    breadCrumbPath: '/billing',
    importLocation: Billing,
  },
  {
    path: '/customers',
    component: <Customers />,
    breadCrumbHeading: 'Customers',
    breadCrumbPath: '/customers',
  },
  {
    path: '/customers/new',
    component: <CreateCustomer />,
    breadCrumbHeading: 'Customers',
    breadCrumbPath: '/customers/new',
  },
  {
    path: '/customers/:id',
    component: <CreateCustomer />,
    breadCrumbHeading: 'Customers',
    breadCrumbPath: '/customers/:id',
  },
  {
    path: '/settings',
    breadCrumbHeading: 'Settings',
    breadCrumbPath: '/settings',
    importLocation: Settings,
  },
  {
    path: '/settings/createwebsite',
    component: <ThemeSelection />,
    breadCrumbHeading: 'Create your website',
    breadCrumbPath: '/settings/createwebsite',
    breadCrumbComponent: (
      <Breadcrumb>
        <Breadcrumb.Item as="div">
          <Link to={'/'}>Website</Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item as="div" active>
          Create your website
        </Breadcrumb.Item>
      </Breadcrumb>
    ),
  },
  {
    path: '/settings/theme',
    breadCrumbHeading: 'Theme',
    breadCrumbPath: '/settings/theme',
    breadCrumbComponent: (
      <Breadcrumb>
        <Breadcrumb.Item as="div">
          <span>Website</span>
        </Breadcrumb.Item>
        <Breadcrumb.Item as="div" active>
          Theme
        </Breadcrumb.Item>
      </Breadcrumb>
    ),
    importLocation: ThemeSettings,
  },
  {
    path: '/settings/header',
    breadCrumbHeading: 'Header',
    breadCrumbPath: '/settings/header',
    breadCrumbComponent: (
      <Breadcrumb>
        <Breadcrumb.Item as="div">
          <span>Website</span>
        </Breadcrumb.Item>
        <Breadcrumb.Item as="div" active>
          Header
        </Breadcrumb.Item>
      </Breadcrumb>
    ),
    importLocation: HeaderFooter,
  },
  {
    path: '/settings/footer',
    breadCrumbHeading: 'Footer',
    breadCrumbPath: '/settings/footer',
    breadCrumbComponent: (
      <Breadcrumb>
        <Breadcrumb.Item as="div">
          <span>Website</span>
        </Breadcrumb.Item>
        <Breadcrumb.Item as="div" active>
          Footer
        </Breadcrumb.Item>
      </Breadcrumb>
    ),
    importLocation: FooterSetting,
  },
  {
    path: '/settings/products',
    component: <Catalogue isProduct />,
    breadCrumbHeading: 'Your Products',
    breadCrumbPath: '/settings/products',
    breadCrumbComponent: (
      <Breadcrumb>
        <Breadcrumb.Item as="div">
          <span>Products</span>
        </Breadcrumb.Item>
        <Breadcrumb.Item as="div" active>
          Your Products
        </Breadcrumb.Item>
      </Breadcrumb>
    ),
  },
  {
    path: '/settings/products/new',
    component: <CreateProduct isFlorist />,
    breadCrumbHeading: 'Your Products',
    breadCrumbPath: '/settings/products/new',
    breadCrumbComponent: (
      <Breadcrumb>
        <Breadcrumb.Item as="div">
          <span>Products</span>
        </Breadcrumb.Item>
        <Breadcrumb.Item as="div" active>
          Your Products
        </Breadcrumb.Item>
      </Breadcrumb>
    ),
  },
  {
    path: '/settings/products/:id',
    component: <CreateProduct isFlorist />,
    breadCrumbHeading: 'Your Products',
    breadCrumbPath: '/settings/products/:id',
    breadCrumbComponent: (
      <Breadcrumb>
        <Breadcrumb.Item as="div">
          <span>Products</span>
        </Breadcrumb.Item>
        <Breadcrumb.Item as="div" active>
          Your Products
        </Breadcrumb.Item>
      </Breadcrumb>
    ),
  },
  {
    path: '/settings/products/details/:id',
    component: <CreateProduct isViewOnly isFlorist />,
    breadCrumbHeading: 'Your Products',
    breadCrumbPath: '/settings/products/details/:id',
    breadCrumbComponent: (
      <Breadcrumb>
        <Breadcrumb.Item as="div">
          <span>Products</span>
        </Breadcrumb.Item>
        <Breadcrumb.Item as="div" active>
          Your Products
        </Breadcrumb.Item>
        <Breadcrumb.Item as="div" active>
          Details
        </Breadcrumb.Item>
      </Breadcrumb>
    ),
  },
  {
    path: '/settings/products/catalog',
    component: <Catalogue isCatalogue isSelectProduct />,
    breadCrumbHeading: 'Catalog',
    breadCrumbPath: '/settings/products/catalog',
    breadCrumbComponent: (
      <Breadcrumb>
        <Breadcrumb.Item as="div">
          <span>Products</span>
        </Breadcrumb.Item>
        <Breadcrumb.Item as="div" active>
          Catalog
        </Breadcrumb.Item>
      </Breadcrumb>
    ),
  },
  {
    path: '/settings/catalog/insights',
    breadCrumbHeading: 'Catalog Insights',
    breadCrumbPath: '/settings/catalog/insights',
    importLocation: newdashboard,
    breadCrumbComponent: (
      <Breadcrumb>
        <Breadcrumb.Item as="div">
          <span>Products</span>
        </Breadcrumb.Item>

        <Breadcrumb.Item as="div" active>
          Catalog Insights
        </Breadcrumb.Item>
      </Breadcrumb>
    ),
  },
  {
    path: '/settings/product/settings',
    breadCrumbHeading: 'Product Settings',
    breadCrumbPath: '/settings/product/settings',
    importLocation: ProductSettings,
    breadCrumbComponent: (
      <Breadcrumb>
        <Breadcrumb.Item as="div">
          <span>Products</span>
        </Breadcrumb.Item>

        <Breadcrumb.Item as="div" active>
          Product Settings
        </Breadcrumb.Item>
      </Breadcrumb>
    ),
  },
  {
    path: '/settings/inventory/Insights',
    component: <InventoryInsights />,
    breadCrumbHeading: 'Inventory Insights',
    breadCrumbPath: '/settings/inventory/Insights',
    breadCrumbComponent: (
      <Breadcrumb>
        <Breadcrumb.Item as="div">
          <span>Products</span>
        </Breadcrumb.Item>
        <Breadcrumb.Item as="div" active>
          Inventory Insights
        </Breadcrumb.Item>
      </Breadcrumb>
    ),
  },
  {
    path: '/settings/products/catalog/details/:id',
    component: <CreateProduct isViewOnly isCatalogue />,
    breadCrumbHeading: 'Catalog',
    breadCrumbPath: '/settings/products/catalog/details/:id',
    breadCrumbComponent: (
      <Breadcrumb>
        <Breadcrumb.Item as="div">
          <span>Website</span>
        </Breadcrumb.Item>
        <Breadcrumb.Item as="div">
          <Link to={'/settings/products'}>Products</Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item as="div" active>
          Catalog
        </Breadcrumb.Item>
        <Breadcrumb.Item as="div" active>
          Details
        </Breadcrumb.Item>
      </Breadcrumb>
    ),
  },
  {
    path: '/settings/gallery-settings',
    // component: <Gallery />,
    breadCrumbHeading: 'Gallery Settings',
    breadCrumbPath: '/settings/gallery-settings',
    breadCrumbComponent: (
      <Breadcrumb>
        <Breadcrumb.Item as="div">
          <span>Website</span>
        </Breadcrumb.Item>
        <Breadcrumb.Item as="div" active>
          Gallery Settings
        </Breadcrumb.Item>
      </Breadcrumb>
    ),
    importLocation: Gallery,
  },
  {
    path: '/settings/inquiries',
    // component: <Inquiries />,
    breadCrumbHeading: 'Inquiries',
    breadCrumbPath: '/settings/inquiries',
    breadCrumbComponent: (
      <Breadcrumb>
        <Breadcrumb.Item as="div">
          <span>Website</span>
        </Breadcrumb.Item>
        <Breadcrumb.Item as="div" active>
          Inquiries
        </Breadcrumb.Item>
      </Breadcrumb>
    ),
    // allowedRoles: ['admin'],
    importLocation: Inquiries,
  },
  {
    path: '/settings/addons',
    // component: <Addons />,
    breadCrumbHeading: 'Add-ons',
    breadCrumbPath: '/settings/addons',
    breadCrumbComponent: (
      <Breadcrumb>
        <Breadcrumb.Item as="div">
          <span>Products</span>
        </Breadcrumb.Item>
        <Breadcrumb.Item as="div" active>
          Add-ons
        </Breadcrumb.Item>
      </Breadcrumb>
    ),
    importLocation: Addons,
  },
  {
    path: '/settings/addons/new',
    // component: <AddEditAddon />,
    breadCrumbHeading: 'Add-ons',
    breadCrumbPath: '/settings/addons/new',
    breadCrumbComponent: (
      <Breadcrumb>
        <Breadcrumb.Item as="div">
          <span>Website</span>
        </Breadcrumb.Item>
        <Breadcrumb.Item as="div" active>
          Add-ons
        </Breadcrumb.Item>
      </Breadcrumb>
    ),
    importLocation: AddEditAddon,
  },
  {
    path: '/settings/addons/:id',
    // component: <AddEditAddon isEdit />,
    breadCrumbHeading: 'Add-ons',
    breadCrumbPath: '/settings/addons/:id',
    breadCrumbComponent: (
      <Breadcrumb>
        <Breadcrumb.Item as="div">
          <span>Website</span>
        </Breadcrumb.Item>
        <Breadcrumb.Item as="div" active>
          Add-ons
        </Breadcrumb.Item>
      </Breadcrumb>
    ),
    importLocation: AddEditAddon,
    parameterProps: {
      isEdit: true,
    },
  },
  {
    path: '/orders',
    // component: <WebsiteOrders />,
    breadCrumbHeading: 'Orders',
    breadCrumbPath: '/orders',
    // breadCrumbComponent: (
    //   <Breadcrumb>
    //     <Breadcrumb.Item as="div" active>
    //       Orders
    //     </Breadcrumb.Item>
    //   </Breadcrumb>
    // ),
    importLocation: WebsiteOrders,
  },
  {
    path: '/reports',
    // component: <WebsiteOrders />,
    breadCrumbHeading: 'Report',
    breadCrumbPath: '/reports',
    importLocation: GenerateReport,
  },
  {
    path: '/deliveries',
    hideBreadCrumb: false,
    breadCrumbHeading: 'Deliveries',
    breadCrumbPath: '/deliveries',
    importLocation: DriverOrder,
  },
  {
    path: '/settings/product/coupons',
    // component: <Addons />,
    breadCrumbHeading: 'Coupons',
    breadCrumbPath: '/settings/product/coupons',
    breadCrumbComponent: (
      <Breadcrumb>
        <Breadcrumb.Item as="div">
          <span>Products</span>
        </Breadcrumb.Item>

        <Breadcrumb.Item as="div">Product Settings</Breadcrumb.Item>
        <Breadcrumb.Item as="div" active>
          Coupons
        </Breadcrumb.Item>
      </Breadcrumb>
    ),
    importLocation: Coupons,
  },
  {
    path: '/settings/product/coupons/new',
    breadCrumbHeading: 'Coupons',
    breadCrumbPath: '/settings/product/coupons/new',
    breadCrumbComponent: (
      <Breadcrumb>
        <Breadcrumb.Item as="div">
          <span>Products</span>
        </Breadcrumb.Item>
        <Breadcrumb.Item as="div">Product Settings</Breadcrumb.Item>
        <Breadcrumb.Item as="div" active>
          Coupons
        </Breadcrumb.Item>
      </Breadcrumb>
    ),
    importLocation: AddCoupon,
  },
  {
    path: '/settings/product/coupons/:id',
    breadCrumbHeading: 'Coupons',
    breadCrumbPath: '/settings/product/coupons/:id',
    breadCrumbComponent: (
      <Breadcrumb>
        <Breadcrumb.Item as="div">
          <span>Products</span>
        </Breadcrumb.Item>
        <Breadcrumb.Item as="div">Product Settings</Breadcrumb.Item>
        <Breadcrumb.Item as="div" active>
          Coupons
        </Breadcrumb.Item>
      </Breadcrumb>
    ),
    importLocation: AddCoupon,
    parameterProps: {
      isEdit: true,
    },
  },
];

export const communicationRoutes = [];

export const TemplateRouteData = [
  {
    path: '/editTemplate',
    // component: <EditTemplate />,
    breadCrumbHeading: 'Template',
    breadCrumbPath: '/editTemplate',
    importLocation: EditTemplate,
  },
];
